import { render, staticRenderFns } from "./EnterpriseDetail.vue?vue&type=template&id=85de74c6"
import script from "./EnterpriseDetail.vue?vue&type=script&lang=js"
export * from "./EnterpriseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports